var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"parent",class:{
    'filter-popover': true,
    'price-filter-footer': _vm.filterName === 'price'
  },style:(_vm.styles)},[(!_vm.$mq.desktop)?_c('header',{staticClass:"filter-popover__header"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"fa-solid fa-xmark fa-lg",on:{"click":function($event){return _vm.$emit('close')}}})]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }